import { parseChapterInfo } from 'api/parsers/parseChapterInfo';
import { fetch } from 'api/typedFetch';

export const getData = async (id: string) => {
  const response = await fetch('GET_CHAPTER_INFO', {
    method: 'GET',
    params: new URLSearchParams({ app_id: id }),
  });
  const data = await response.json();

  return data.app
    .map((chapter) => {
      return parseChapterInfo(chapter, id);
    })
    .filter((chapter) => {
      return !chapter.hiddenInSource;
    });
};
